import * as yup from 'yup';
import { TShippingFormData, TDeliveryMethod } from '../../Checkout.types';

export const shippingSchema = yup
  .object({
    firstName: yup
      .string()
      .required('Imię jest wymagane')
      .min(2, 'Imię musi mieć co najmniej 2 znaki'),
    lastName: yup
      .string()
      .required('Nazwisko jest wymagane')
      .min(2, 'Nazwisko musi mieć co najmniej 2 znaki'),
    email: yup
      .string()
      .required('Email jest wymagany')
      .email('Nieprawidłowy format email'),
    phone: yup
      .string()
      .required('Numer telefonu jest wymagany')
      .matches(/^[0-9]{9}$/, 'Numer telefonu musi mieć 9 cyfr'),
    street: yup
      .string()
      .required('Ulica jest wymagana')
      .min(3, 'Ulica musi mieć co najmniej 3 znaki'),
    buildingNumber: yup
      .string()
      .required('Numer budynku jest wymagany')
      .matches(/^[0-9]+[A-Za-z]?$/, 'Nieprawidłowy format numeru budynku'),
    apartmentNumber: yup.string().optional(),
    city: yup
      .string()
      .required('Miasto jest wymagane')
      .min(2, 'Miasto musi mieć co najmniej 2 znaki'),
    postalCode: yup
      .string()
      .required('Kod pocztowy jest wymagany')
      .matches(
        /^[0-9]{2}-[0-9]{3}$/,
        'Kod pocztowy musi być w formacie XX-XXX'
      ),
    deliveryMethod: yup
      .mixed<TDeliveryMethod>()
      .oneOf(
        ['inpost', 'dpd', 'poczta', 'kurier'],
        'Metoda dostawy jest wymagana'
      )
      .required('Metoda dostawy jest wymagana'),
    deliveryPointId: yup.string().optional(),
    deliveryPointName: yup.string().optional(),
  })
  .test('inpost-required', function (value) {
    if (value?.deliveryMethod === 'inpost' && !value?.deliveryPointId) {
      return this.createError({
        path: 'deliveryPointId',
        message: 'Wybierz paczkomat',
      });
    }
    return true;
  }) as yup.ObjectSchema<TShippingFormData>;
